"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IRendererPropsExtender.js.map